import * as React from 'react';
import { connect } from 'react-redux';

import { TextField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { changePhone } from '../../../state/advanced/phone';
import { InlineLabel, InlineParam, Row } from '../markup';

interface IPhoneProps {
  phone: string | undefined;
  onPhoneChanged(phone: string | undefined): void;
}

const phone: React.StatelessComponent<IPhoneProps> = props => (
  <Row title="Контактный телефон">
    <InlineLabel>+7</InlineLabel>
    <InlineParam>
      <TextField
        type="phone"
        value={props.phone || ''}
        mask="9999999999"
        onValueChange={value => {
          const newValue = value.replace(/\D+/g, '');
          props.onPhoneChanged(newValue || undefined);
        }}
      />
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    phone: state.filters.jsonQuery.contact && state.filters.jsonQuery.contact.value,
  }),
  (dispatch: Dispatch) => ({
    onPhoneChanged: (value: string | undefined) => {
      dispatch(changePhone(value));
    },
  }),
)(phone);
